import { type HttpClientInterface } from '../../infra/http/HttpClient'
import { mapApiToTags, type RawShipmentTag } from './ShipmentTagsMapper'

type ShipmentTagRepositoryDependencies = {
  httpClient: HttpClientInterface
}

export class ShipmentTagRepository {
  private httpClient: HttpClientInterface

  constructor({ httpClient }: ShipmentTagRepositoryDependencies) {
    this.httpClient = httpClient
  }

  async fetchCarrierShipmentTags(config?: { signal?: AbortSignal }) {
    const endpoint = 'carrier/shipments/tags'

    const result = await this.httpClient.get<RawShipmentTag[]>(endpoint, config)

    const tags = result.data

    return mapApiToTags(tags)
  }
}
